module.exports = __webpack_public_path__ + "static/media/polojenie_scratch.56d9e52d.pdf";